import React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { deriveRedirectTarget, RULES_ROUTE } from "components/router/Routes";

export default function RulesView() {
    const isRouteEnabled = useIsRouteEnabled();
    const target = deriveRedirectTarget(RULES_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
}
